<div class="theme-lab">
  <header class="theme-lab-header">
    <h1>Theme Lab</h1>
    <p>Before (frozen reproduction of the old screen) vs. after (the real, live component) side by side. Growing as each fix lands.</p>
  </header>

  <section class="theme-lab-item">
    <h2>World Builder &mdash; Abort World Creation confirm</h2>

    <div class="theme-lab-compare">
      <div class="theme-lab-pane">
        <span class="theme-lab-tag theme-lab-tag--before">BEFORE</span>

        <!-- Frozen static reproduction of the old markup/colors. Not live, not part of the app. -->
        <div class="frozen-abort-modal">
          <div class="frozen-header">ABORT WORLD CREATION</div>
          <div class="frozen-body">Are you sure you want to abort the world creation flow? All saved/unsaved values will be lost.</div>
          <div class="frozen-btn-wrapper">
            <button type="button" class="frozen-btn frozen-btn-cancel" disabled>Cancel</button>
            <button type="button" class="frozen-btn frozen-btn-green" disabled>Yes, Abort</button>
          </div>
        </div>
      </div>

      <div class="theme-lab-pane">
        <span class="theme-lab-tag theme-lab-tag--after">AFTER</span>
        <p class="theme-lab-pane-hint">Click to open the real, current component:</p>
        <button type="button" class="btn btn-theme" (click)="openAbortConfirmModal()">
          Open &ldquo;Abort World Creation&rdquo;
        </button>
      </div>
    </div>
  </section>

  <section class="theme-lab-item">
    <h2>Leave City confirm &mdash; was its own one-off component, now uses the shared confirm dialog</h2>

    <div class="theme-lab-compare">
      <div class="theme-lab-pane">
        <span class="theme-lab-tag theme-lab-tag--before">BEFORE</span>

        <div class="frozen-ecity-modal">
          <div class="frozen-ecity-header">PLEASE CONFIRM</div>
          <div class="frozen-ecity-body">Do you want to leave this city and move to Main Map?</div>
          <div class="frozen-btn-wrapper">
            <button type="button" class="frozen-btn frozen-btn-cancel" disabled>Cancel</button>
            <button type="button" class="frozen-btn frozen-btn-green" disabled>Yes</button>
          </div>
        </div>
      </div>

      <div class="theme-lab-pane">
        <span class="theme-lab-tag theme-lab-tag--after">AFTER</span>
        <p class="theme-lab-pane-hint">Click to open the real, current component:</p>
        <button type="button" class="btn btn-theme" (click)="openLeaveCityConfirm()">
          Open &ldquo;Leave This City?&rdquo;
        </button>
      </div>
    </div>
  </section>

  <section class="theme-lab-item">
    <h2>Uninvite confirm &mdash; was its own one-off component, now uses the shared confirm dialog</h2>

    <div class="theme-lab-compare">
      <div class="theme-lab-pane">
        <span class="theme-lab-tag theme-lab-tag--before">BEFORE</span>

        <div class="frozen-ecity-modal">
          <div class="frozen-ecity-header">PLEASE CONFIRM</div>
          <div class="frozen-ecity-body">Do you want to Really Uninvite?</div>
          <div class="frozen-btn-wrapper">
            <button type="button" class="frozen-btn frozen-btn-cancel" disabled>Cancel</button>
            <button type="button" class="frozen-btn frozen-btn-green" disabled>Yes</button>
          </div>
        </div>
      </div>

      <div class="theme-lab-pane">
        <span class="theme-lab-tag theme-lab-tag--after">AFTER</span>
        <p class="theme-lab-pane-hint">Click to open the real, current component:</p>
        <button type="button" class="btn btn-theme" (click)="openUninviteConfirm()">
          Open &ldquo;Please Confirm&rdquo; (uninvite)
        </button>
      </div>
    </div>
  </section>

  <section class="theme-lab-item">
    <h2>Remove Character / Disband Party &mdash; icon + tokens + fixed button semantics</h2>

    <div class="theme-lab-compare">
      <div class="theme-lab-pane">
        <span class="theme-lab-tag theme-lab-tag--before">BEFORE</span>
        <div class="frozen-abort-modal">
          <div class="frozen-header">Please Confirm</div>
          <div class="frozen-body">By clicking Confirm, the Character selected will be removed from the party. Proceed only if you&rsquo;re ready to part ways.</div>
          <div class="frozen-btn-wrapper">
            <button type="button" class="frozen-btn frozen-btn-cancel" disabled>Cancel</button>
            <button type="button" class="frozen-btn frozen-btn-green" disabled>Remove</button>
          </div>
        </div>
      </div>

      <div class="theme-lab-pane">
        <span class="theme-lab-tag theme-lab-tag--after">AFTER</span>
        <p class="theme-lab-pane-hint">Note: old "Remove" button was green (success color) for a destructive action &mdash; now danger red.</p>
        <div class="theme-lab-row">
          <button type="button" class="btn btn-theme" (click)="openRemoveCharacterModal()">Open &ldquo;Remove Character&rdquo;</button>
          <button type="button" class="btn btn-theme" (click)="openDisbandPartyModal()">Open &ldquo;Disband Party&rdquo;</button>
        </div>
      </div>
    </div>
  </section>

  <section class="theme-lab-item">
    <h2>Remove Content From Storefront &mdash; also removed dead unused CSS (gradient classes that were never applied)</h2>

    <div class="theme-lab-compare">
      <div class="theme-lab-pane">
        <span class="theme-lab-tag theme-lab-tag--before">BEFORE</span>
        <div class="frozen-abort-modal">
          <div class="frozen-header">Notice</div>
          <div class="frozen-body">When you delete content, it is taken off the Storefront and no new purchases can be made.</div>
          <div class="frozen-btn-wrapper">
            <button type="button" class="frozen-btn frozen-btn-cancel" disabled>Cancel</button>
            <button type="button" class="frozen-btn frozen-btn-green" disabled>OK</button>
          </div>
        </div>
      </div>

      <div class="theme-lab-pane">
        <span class="theme-lab-tag theme-lab-tag--after">AFTER</span>
        <p class="theme-lab-pane-hint">Note: old "OK" (a destructive delete) was green &mdash; now danger red.</p>
        <button type="button" class="btn btn-theme" (click)="openContentDeleteConfirm()">
          Open &ldquo;Remove From Storefront&rdquo;
        </button>
      </div>
    </div>
  </section>

  <section class="theme-lab-item">
    <h2>Delete / Enter City &mdash; multi-purpose modal, worst button-semantics bug found (Close was green, Delete was gold)</h2>

    <div class="theme-lab-compare">
      <div class="theme-lab-pane">
        <span class="theme-lab-tag theme-lab-tag--before">BEFORE</span>
        <div class="frozen-abort-modal">
          <div class="frozen-header">Delete Confirmation</div>
          <div class="frozen-body">Are you sure you want to delete this map</div>
          <div class="frozen-btn-wrapper">
            <button type="button" class="frozen-btn frozen-btn-green" disabled>Close</button>
            <button type="button" class="frozen-btn frozen-btn-cancel" disabled>Delete</button>
          </div>
        </div>
      </div>

      <div class="theme-lab-pane">
        <span class="theme-lab-tag theme-lab-tag--after">AFTER</span>
        <p class="theme-lab-pane-hint">Note: "Close" was green and "Delete" was gold &mdash; completely backwards. Now Cancel is outline, Delete is danger red.</p>
        <div class="theme-lab-row">
          <button type="button" class="btn btn-theme" (click)="openDeleteConfirm()">Open &ldquo;Delete Confirmation&rdquo;</button>
          <button type="button" class="btn btn-theme" (click)="openEnterCityConfirm()">Open &ldquo;Enter The City?&rdquo;</button>
        </div>
      </div>
    </div>
  </section>

  <section class="theme-lab-item">
    <h2>Subscription Downgrade Chain &mdash; the most destructive flow in the app; "Proceed"/"Subscribe"/"Delete" were all green, ~40 inline styles per screen removed</h2>

    <div class="theme-lab-compare">
      <div class="theme-lab-pane">
        <span class="theme-lab-tag theme-lab-tag--before">BEFORE</span>
        <div class="frozen-abort-modal">
          <div class="frozen-header">Map Cleanup</div>
          <div class="frozen-body">Items In RED will be deleted &mdash; table row + buttons all hand-styled with inline <code>style=""</code> attributes on every cell.</div>
          <div class="frozen-btn-wrapper">
            <button type="button" class="frozen-btn frozen-btn-cancel" disabled>Cancel</button>
            <button type="button" class="frozen-btn frozen-btn-green" disabled>Proceed</button>
          </div>
        </div>
      </div>

      <div class="theme-lab-pane">
        <span class="theme-lab-tag theme-lab-tag--after">AFTER</span>
        <p class="theme-lab-pane-hint">Shared <code>cleanup-modal</code> mixin across all 3 screens; inline styles removed; Proceed/Subscribe now gold, real destructive delete (checkbox gate) is danger red.</p>
        <div class="theme-lab-row">
          <button type="button" class="btn btn-theme" (click)="openMapCleanup()">Map cleanup</button>
          <button type="button" class="btn btn-theme" (click)="openGameCleanup()">Game cleanup</button>
          <button type="button" class="btn btn-theme" (click)="openCharacterCleanup()">Character cleanup</button>
          <button type="button" class="btn btn-theme" (click)="openAccountCleanupWizard()">Account cleanup wizard</button>
          <button type="button" class="btn btn-theme" (click)="openMapDeleteGate()">Delete Map (checkbox gate)</button>
        </div>
      </div>
    </div>
  </section>

  <section class="theme-lab-item">
    <h2>Beta Announcement / Saving Loader / Token Placement &mdash; migrated or modernized in place</h2>

    <div class="theme-lab-compare">
      <div class="theme-lab-pane">
        <span class="theme-lab-tag theme-lab-tag--before">BEFORE</span>
        <div class="frozen-abort-modal">
          <div class="frozen-header">WorldTumbler Beta Is Live</div>
          <div class="frozen-body">We appreciate you joining our early access community.</div>
          <div class="frozen-btn-wrapper">
            <button type="button" class="frozen-btn frozen-btn-green" disabled>Continue</button>
          </div>
        </div>
      </div>

      <div class="theme-lab-pane">
        <span class="theme-lab-tag theme-lab-tag--after">AFTER</span>
        <p class="theme-lab-pane-hint">Beta announcement migrated to the shared dialog; loader gets a branded spinner; token-placement gained an explicit "Got It" button (previously only a tiny close X).</p>
        <div class="theme-lab-row">
          <button type="button" class="btn btn-theme" (click)="openBetaAnnouncement()">Beta announcement</button>
          <button type="button" class="btn btn-theme" (click)="openSavingLoader()">Saving loader</button>
          <button type="button" class="btn btn-theme" (click)="openTokenPlacement()">Token placement</button>
        </div>
      </div>
    </div>
  </section>

  <section class="theme-lab-item">
    <h2>Reporting / Journal / Notes / Favorites &mdash; forms retokenized, dead commented-out markup removed (one had ~30 dead lines from a prior redesign)</h2>

    <div class="theme-lab-compare">
      <div class="theme-lab-pane">
        <span class="theme-lab-tag theme-lab-tag--before">BEFORE</span>
        <div class="frozen-abort-modal">
          <div class="frozen-header">Reporting</div>
          <div class="frozen-body">Textarea on a plain dark box, red hex error text, unlabeled inputs, oversized 32px form labels left over from an earlier layout.</div>
          <div class="frozen-btn-wrapper">
            <button type="button" class="frozen-btn frozen-btn-green" disabled>Report</button>
          </div>
        </div>
      </div>

      <div class="theme-lab-pane">
        <span class="theme-lab-tag theme-lab-tag--after">AFTER</span>
        <p class="theme-lab-pane-hint">Form fields now match the signup-page input pattern (sunken surface, gold focus ring) used everywhere else in the app.</p>
        <div class="theme-lab-row">
          <button type="button" class="btn btn-theme" (click)="openReportingModal()">Reporting</button>
          <button type="button" class="btn btn-theme" (click)="openPlayerStory()">Game journal</button>
          <button type="button" class="btn btn-theme" (click)="openNoteList()">Notes list</button>
          <button type="button" class="btn btn-theme" (click)="openCategoryPlayerView()">Game Favorite (pin)</button>
        </div>
      </div>
    </div>
  </section>

  <section class="theme-lab-item">
    <h2>Active Games / Maplist modals &mdash; several were completely unstyled light-theme leftovers (white bg, red buttons, plain "X" close)</h2>

    <div class="theme-lab-compare">
      <div class="theme-lab-pane">
        <span class="theme-lab-tag theme-lab-tag--before">BEFORE</span>
        <p class="theme-lab-pane-hint">editgamemasterdetail / creategame / gamemasterdetail-imgupload used raw Arial-on-white forms with a red "X" close button &mdash; the light-mode Bootstrap defaults, never touched by any redesign pass.</p>
      </div>

      <div class="theme-lab-pane">
        <span class="theme-lab-tag theme-lab-tag--after">AFTER</span>
        <p class="theme-lab-pane-hint">Also found: "Delete Map" was gold (not danger red) on the map-modify page, and "Your map IS beING upLoAded!" had random capitalization.</p>
        <div class="theme-lab-row">
          <button type="button" class="btn btn-theme" (click)="openCreateGameInfo()">Welcome to map</button>
          <button type="button" class="btn btn-theme" (click)="openUploadPartyToken()">Select token</button>
          <button type="button" class="btn btn-theme" (click)="openCreateGame()">New game</button>
          <button type="button" class="btn btn-theme" (click)="openAzgaarInfo()">Azgaar info</button>
          <button type="button" class="btn btn-theme" (click)="openMapImageChange()">Update map image</button>
        </div>
        <p class="theme-lab-pane-hint" style="margin-top: 12px;">
          Full pages (visit directly, ?preview=1): <code>/map-modify/1</code>, <code>/addmapdata</code>, <code>/editmapdata</code>
        </p>
      </div>
    </div>
  </section>
</div>
